<div class="channel-code">
  <div
    class="close-sign"
    [inlineSVG]="closeIcon"
    (click)="onCloseButtonClicked($event)"
  ></div>
  <div class="triangle-with-shadow"></div>
  <header>CREATE HLS URL:</header>
  <section>
    <span class="label">Expiry:</span>
    <input type="number" min="1" max="15" step="1" [(ngModel)]="expiryDays" />
    <span class="label">Days</span>
    <textarea [ngModel]="url"></textarea>
    <p>
      <button *ngIf="url === ''" (click)="createUrl()">Create</button>
      <button *ngIf="url !== ''" (click)="goToUrl()">Go To</button>
    </p>
  </section>
</div>
